import { render } from "./DefaultLayout.vue?vue&type=template&id=241e6556&scoped=true"
const script = {}

import "./DefaultLayout.vue?vue&type=style&index=0&id=241e6556&scoped=true&lang=css"

import exportComponent from "C:\\Users\\vinicius.martins\\Desktop\\pasta\\teste\\projeto-automacao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241e6556"]])

export default __exports__